import { loadable } from '@shared/core/loadableFromNamedExport';

// The intro only opens when a couple clicks publish with Go Live Checks on. Consumers gate its render
// behind `isOpen`, so this chunk stays out of every publish surface's bundle — the guest site's
// included, where most visitors are guests who never see it.
export const LazyGoLiveChecksIntro = loadable(() => import(/* webpackChunkName: "shared/go-live-checks-intro" */ './GoLiveChecksIntro'), 'GoLiveChecksIntro');
